<template>
    <el-header>
      <el-row>
        <el-col :span="3">&nbsp;</el-col>
        <el-col :span="4">
          <el-link v-bind:underline="false" href="/">
            <el-image :src="require('@/assets/apidock.svg')" :alt="'网湖首页'" style="display: block; width: 38px; height: 38px;"></el-image>
            <!--<h2 style="display: inline; color: #00f; font-size: 10px;">导航入口</h2>-->
          </el-link>
        </el-col>
        <el-col :span="14">
          <el-menu v-bind:text-color="'#00f'" v-model="user" class="el-menu-demo" mode="horizontal">
            <el-menu-item>
              <el-link v-bind:underline="false" href="/nav/list">导航列表</el-link>
            </el-menu-item>
            <el-menu-item v-if="Object.keys(user).length > 0">
              <el-link v-bind:underline="false" href="/setting">导航设置</el-link>
            </el-menu-item>
            <el-menu-item v-if="Object.keys(user).length > 0">
              <el-link v-bind:underline="false" href="/user">个人中心</el-link>
            </el-menu-item>
            <el-menu-item>
              <el-link v-bind:underline="false" href="/about">关于我们</el-link>
            </el-menu-item>
            <el-menu-item>
              <el-link v-if="Object.keys(user).length === 0" v-bind:underline="false" href="/login">登录</el-link>
              <el-link v-if="Object.keys(user).length > 0" v-bind:underline="false" v-on:click="logout">退出登录</el-link>
            </el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="3">&nbsp;</el-col>
      </el-row>
    </el-header>
</template>
<script>
export default {
  name: 'Header',
  data () {
    return {
      user: {}
    }
  },
  created: function () {
    this.$http.defaults.baseURL = process.env.VUE_APP_BASE_API
    this.getUser()
  },
  methods: {
    getUser () {
      if (localStorage.getItem('token') == null) {
        return
      }
      if (this.$route.path === '/login') {
        this.$router.push('/')
      }
      this.$http.get('user/get', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then((response) => {
        if (response.data.code === 0) {
          this.user = response.data.data
        } else if (response.data.code === 80003) {
          localStorage.removeItem('token')
          this.user = {}
        } else {
          this.$message({message: response.data.msg, type: 'error'})
        }
      })
    },
    logout () {
      this.$http.get('auth/logout', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then((response) => {
        if (response.data.code === 0 || response.data.code === 80003) {
          localStorage.clear()
          this.user = {}
          if (this.$route.path === '/user') {
            this.$router.push('/')
          }
        } else {
          this.$message({message: response.data.msg, type: 'error'})
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-header {
  height: 60px!important;
  line-height: 60px;
  background: #FFFFFF;
  align-items: center;
}
.el-header .el-col {
  max-height: 60px;
  overflow: hidden;
}
.el-header .el-col-4,.el-col-14 {
  border-bottom: 1px solid #dcdfe6;
}
.el-menu {
  min-width: 270px;
  margin-left: 10%;
}
.el-menu li {
  height: 60px!important;
  line-height: 60px;
}
.el-menu .el-link {
  font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue